import { fetchApi } from "../utils/fetchApi";

export function fetchActivecarinfo({ filter = {}, options = {} }) {
  return fetchApi({ url: `vehicle/activecar/`, filter: {}, options });
}

